// extracted by mini-css-extract-plugin
export default {"closeSection":"occupancy_settings_form_closeSection__ACcOR"};